export const configuratorLink = (configLink, siteLanguage, originalId) => {
  if (configLink) {
    // Check if configLink already contains query parameters
    configLink = configLink.includes('?')
      ? configLink + `&sourcelanguage=${siteLanguage}` + (originalId ? `&sourcematerialcode=${originalId}` : '')
      : configLink + `?sourcelanguage=${siteLanguage}` + (originalId ? `&sourcematerialcode=${originalId}` : '');
  }

  return configLink || '';
}
